import { render, staticRenderFns } from "./material-modal.vue?vue&type=template&id=01cc6a24&scoped=true"
import script from "./material-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./material-modal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-modal.vue?vue&type=style&index=0&id=01cc6a24&prod&lang=scss"
import style1 from "./material-modal.vue?vue&type=style&index=1&id=01cc6a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cc6a24",
  null
  
)

export default component.exports